export default __webpack_public_path__ + "static/media/50.773bce62.svg";